// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/deployer/v1/deployment_status.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Scorer } from "./scorer_pb.js";

/**
 * Possible progression of states:
 *
 * PREPARING   ::> LAUNCHING | FAILED
 * LAUNCHING   ::> HEALTHY | FAILED
 * FAILED      ::> PREPARING
 * HEALTHY     ::> UNHEALTHY | TERMINATING
 * UNHEALTHY   ::> HEALTHY | TERMINATING
 * TERMINATING ::> (N/A)
 *
 * @generated from enum ai.h2o.deploy.DeploymentState
 */
export const DeploymentState = /*@__PURE__*/ proto3.makeEnum(
  "ai.h2o.deploy.DeploymentState",
  [
    {no: 0, name: "DEPLOYMENT_STATE_UNSPECIFIED"},
    {no: 1, name: "PREPARING"},
    {no: 2, name: "LAUNCHING"},
    {no: 3, name: "FAILED"},
    {no: 4, name: "HEALTHY"},
    {no: 5, name: "UNHEALTY"},
    {no: 6, name: "TERMINATING"},
    {no: 7, name: "PENDING"},
  ],
);

/**
 * Represents the status of a deployment in an environment.
 *
 * @generated from message ai.h2o.deploy.DeploymentStatus
 */
export const DeploymentStatus = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.DeploymentStatus",
  () => [
    { no: 1, name: "deployment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "state", kind: "enum", T: proto3.getEnumType(DeploymentState) },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "last_modified_time", kind: "message", T: Timestamp },
    { no: 6, name: "scorer", kind: "message", T: Scorer },
  ],
);

